/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HighScoringMatchInfo
 */
export interface HighScoringMatchInfo {
    /**
     * 
     * @type {string}
     * @memberof HighScoringMatchInfo
     */
    matchId?: string;
    /**
     * 
     * @type {string}
     * @memberof HighScoringMatchInfo
     */
    teamAName?: string;
    /**
     * 
     * @type {string}
     * @memberof HighScoringMatchInfo
     */
    teamBName?: string;
    /**
     * 
     * @type {number}
     * @memberof HighScoringMatchInfo
     */
    teamAScore?: number;
    /**
     * 
     * @type {number}
     * @memberof HighScoringMatchInfo
     */
    teamBScore?: number;
    /**
     * 
     * @type {number}
     * @memberof HighScoringMatchInfo
     */
    totalScore?: number;
    /**
     * 
     * @type {Date}
     * @memberof HighScoringMatchInfo
     */
    matchTime?: Date | null;
}

/**
 * Check if a given object implements the HighScoringMatchInfo interface.
 */
export function instanceOfHighScoringMatchInfo(value: object): value is HighScoringMatchInfo {
    return true;
}

export function HighScoringMatchInfoFromJSON(json: any): HighScoringMatchInfo {
    return HighScoringMatchInfoFromJSONTyped(json, false);
}

export function HighScoringMatchInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HighScoringMatchInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
        'teamAName': json['teamAName'] == null ? undefined : json['teamAName'],
        'teamBName': json['teamBName'] == null ? undefined : json['teamBName'],
        'teamAScore': json['teamAScore'] == null ? undefined : json['teamAScore'],
        'teamBScore': json['teamBScore'] == null ? undefined : json['teamBScore'],
        'totalScore': json['totalScore'] == null ? undefined : json['totalScore'],
        'matchTime': json['matchTime'] == null ? undefined : (new Date(json['matchTime'])),
    };
}

export function HighScoringMatchInfoToJSON(json: any): HighScoringMatchInfo {
    return HighScoringMatchInfoToJSONTyped(json, false);
}

export function HighScoringMatchInfoToJSONTyped(value?: HighScoringMatchInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'teamAName': value['teamAName'],
        'teamBName': value['teamBName'],
        'teamAScore': value['teamAScore'],
        'teamBScore': value['teamBScore'],
        'totalScore': value['totalScore'],
        'matchTime': value['matchTime'] == null ? value['matchTime'] : value['matchTime'].toISOString(),
    };
}

